import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, ClipboardCheck, Timer, Atom, Sigma, FlaskConical, BarChart3 } from "lucide-react";

const POINTS = [
  { icon: Timer, t: "20 λεπτά, 10 ερωτήσεις", d: "Πολλαπλής επιλογής, 3 επίπεδα δυσκολίας" },
  { icon: BarChart3, t: "Ανάλυση ανά ενότητα", d: "Βλέπεις ακριβώς πού έχεις κενά" },
  { icon: ClipboardCheck, t: "Σωστές λύσεις & επεξηγήσεις", d: "Για κάθε ερώτηση που έκανες λάθος" },
];

export default function DiagnosticCard() {
  return (
    <section id="diagnostic" data-testid="diagnostic-section" className="py-20 md:py-32 bg-foreground text-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <motion.div initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.45 }}>
          <div className="font-mono-accent text-xs uppercase tracking-[0.2em] text-accent mb-4">// Δωρεάν διαγνωστικό τεστ</div>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-tight">Πού βρίσκεσαι πραγματικά; Μάθε σε 20 λεπτά.</h2>
          <p className="mt-4 text-white/70 leading-relaxed">Φυσική, Μαθηματικά ή Χημεία για Γ' Γυμνασίου και Α' Λυκείου. Χωρίς εγγραφή για να ξεκινήσεις — στο τέλος βλέπεις σκορ και ανάλυση, και αν θέλεις ξεκλειδώνεις τις λύσεις.</p>
          <div className="flex gap-3 mt-6">
            {[Atom, Sigma, FlaskConical].map((Icon, i) => <span key={i} className="h-11 w-11 flex items-center justify-center rounded-sm bg-white/10 text-accent"><Icon className="h-5 w-5" strokeWidth={1.5} /></span>)}
          </div>
          <Link to="/test" data-testid="diagnostic-cta" className="group mt-8 inline-flex items-center gap-2 bg-accent text-white font-mono-accent text-xs uppercase tracking-widest px-7 py-4 rounded-sm hover:bg-white hover:text-foreground transition-colors">
            Ξεκίνα το τεστ <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </motion.div>
        <div className="grid gap-4">
          {POINTS.map((p, i) => { const Icon = p.icon; return (
            <motion.div key={p.t} initial={{ opacity: 0, x: 18 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.1 }} className="flex gap-4 bg-white/5 border border-white/15 rounded-sm p-5">
              <span className="h-10 w-10 shrink-0 flex items-center justify-center rounded-sm bg-white/10"><Icon className="h-5 w-5 text-accent" strokeWidth={1.5} /></span>
              <div><div className="font-heading font-bold">{p.t}</div><div className="text-sm text-white/60 mt-0.5">{p.d}</div></div>
            </motion.div>); })}
        </div>
      </div>
    </section>
  );
}
